import { render, staticRenderFns } from "./RulePage.vue?vue&type=template&id=fa3f41ea&scoped=true&"
import script from "./RulePage.vue?vue&type=script&lang=js&"
export * from "./RulePage.vue?vue&type=script&lang=js&"
import style0 from "./RulePage.vue?vue&type=style&index=0&id=fa3f41ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3f41ea",
  null
  
)

export default component.exports